export default "__VITE_ASSET__DfTtrXkw__"